import { EXTENSIONS_AB_TEST_ID_PREFIX } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { AbTestTypeCategory } from '../models/AbTestCreationType';
import { AbTest } from '../models/AbTest';
import { AbTestType } from '../models/AbTestType';

export const getAbTestType = (abTest: AbTest): AbTestType => {
  if (!abTest.startedAt) {
    return AbTestType.DRAFT;
  }
  if (abTest.startedAt && !abTest.endedAt) {
    return AbTestType.RUNNING;
  }
  return AbTestType.CONCLUDED;
};

export const getAbTestTypeCategory = (abTest: AbTest): AbTestTypeCategory => {
  if (abTest.testType === AbTestTypeCategory.EXTENSIONS) {
    return AbTestTypeCategory.EXTENSIONS;
  }
  if (abTest.testType === AbTestTypeCategory.EXTENSIONS_GROUPS) {
    return AbTestTypeCategory.EXTENSIONS_GROUPS;
  }
  return AbTestTypeCategory.SHIPPING_RATES;
};
const isExtensionsAbTest = (testType: AbTestTypeCategory | undefined): boolean =>
  testType === AbTestTypeCategory.EXTENSIONS || testType === AbTestTypeCategory.EXTENSIONS_GROUPS;

export const getAbTestDuplicationTestIdString = (abTest: AbTest): string =>
  isExtensionsAbTest(abTest.testType)
    ? `${EXTENSIONS_AB_TEST_ID_PREFIX}${abTest.id.toString()}`
    : `EnterABTest-${abTest.id.toString()}`;

export const getAbTestVariantPreviewString = (
  testType: AbTestTypeCategory | undefined,
  abTestId: number | undefined,
  variantName: string,
): string | null => (abTestId && isExtensionsAbTest(testType) ? `pdq_test_preview_${abTestId}_${variantName}` : null);

export const getSetWinnerDialogText = (): string => {
  return 'By setting this checkout group as a winner, it will be set live for the selected segments';
};

export const getCheckoutProfileWinnerDialogText = (): string => {
  return 'Marking this checkout profile as the winner records the result in PDQ. Publish the winning profile in Shopify to apply it.';
};

export const generateAnalyticsDashboardUrl = (abTest: AbTest, winningSegmentClean?: string | null): string => {
  const isCrossSiteTest = abTest.testType === AbTestTypeCategory.CROSS_SITE;
  const paramName = isCrossSiteTest ? 'CrossSitetestTestName' : 'testName';
  const segmentParam =
    !isCrossSiteTest && winningSegmentClean ? `&segmentparameter=${encodeURIComponent(winningSegmentClean)}` : '';

  return `/optimize/dashboard?${paramName}=${encodeURIComponent(abTest.name)}${segmentParam}&sheetName=test-results`;
};
